import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import { decrypt, encrypt } from "../utils/cryptoUtils";
import { makeAuthenticatedRequest } from "../utils/api";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { AxiosError } from "../components/sessionexpiry";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Initiatepayoutmerchants_ip } from "../redux/InitiatepayoutSlice";
import { Link } from "react-router-dom";

const UpdateIP = ({ isSidebarCollapsed, isMobile }) => {
  // const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [ipAddress, setIpAddress] = useState("");
  const [error, setError] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();  // Get the location object
  const { id } = location.state || {};  // Extract state from location

  // const toggleSidebar = () => {
  //   setIsSidebarCollapsed(!isSidebarCollapsed);
  // };

  const toggleModal = () => {
    setIsModalVisible(!isModalVisible);
    setIpAddress(""); // Reset input when closing the modal
    setError("");
  };

  const handleIpChange = (e) => {
    setIpAddress(e.target.value);
    setError("");
  };

  const validateIp = (ip) => {
    const ipRegex =
      /^(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)$/;
    return ipRegex.test(ip);
  };

  const handleSubmit = () => {
    if (!validateIp(ipAddress)) {
      setError("Please enter a valid IPv4 address.");
      return;
    }

    // Handle valid IP submission (e.g., send to server, update state, etc.)
    console.log("Valid IP submitted:", ipAddress);
    updateData(1);
    toggleModal()
  };

  const updateData = async (status) => {
    try {
      // 1. Check how many active entries this user has
      const countQuery = JSON.stringify({
        Dname: "flipopay_payouts",
        Tname: "ip_whitelist",
        Cname: ["count(*)"],
        Where: [
          { 
            column: "mid",
            operator: "=",
            value: id 
          },
          { 
            column: "status",
            operator: "=",
            value: "1"
          }
        ],
        Limit: "10",
        Offset: "0",
      });
  
      const encryptedCount = encrypt(countQuery);
      const countRes = await makeAuthenticatedRequest(
        "POST",
        "/fetch",
        { encrypted: encryptedCount },
        navigate
      );
  
      const decryptedCount = JSON.parse(decrypt(countRes).replace(/\\"/g, '"'));
      const activeCount = parseInt(decryptedCount[1]["count(*)"] || "0");
  
      if (activeCount >= 3 && status === 1) {
        toast.error("Only 3 active IPs are allowed per merchant.");
        return;
      }
  
      // 2. Check if this IP is already used by another merchant
      const ipCheckQuery = JSON.stringify({
        Dname: "flipopay_payouts",
        Tname: "ip_whitelist",
        Cname: ["mid", "status"],
        Where: [
          {
            column:"ip",
            operator:"=",
            value:ipAddress
          },
          {
            column:"status",
            operator:"=",
            value:"1"
          }
        ],
        Limit: "10",
        Offset: "0",
      });
  
      const encryptedIP = encrypt(ipCheckQuery);
      const ipCheckRes = await makeAuthenticatedRequest(
        "POST",
        "/fetch",
        { encrypted: encryptedIP },
        navigate
      );
  
      const ipResult = JSON.parse(decrypt(ipCheckRes).replace(/\\"/g, '"'));
  
      if (
        ipResult.length > 1 &&
        ipResult[1].mid !== id &&
        status === 1
      ) {
        toast.error("This IP is already in use by another merchant.");
        return;
      }
      if (
        ipResult.length > 1 &&
        ipResult[1].mid === id &&
        status === 1
      ) {
        toast.error("This IP is already Submitted.");
        return;
      }
  
      // 3. If validations pass, proceed to update
      const updateJson = JSON.stringify({
        Dname: "flipopay_payouts",
        Tname: "ip_whitelist",
        Values: {
          mid:id,
          ip: ipAddress,
          status: status,
        },
      });
  
      console.log("Final JSON:", updateJson);
  
      const encrypted = encrypt(updateJson);
  
      const response = await makeAuthenticatedRequest(
        "POST",
        "/insert",
        { encrypted: encrypted },
        navigate
      );

      const decryptdata = decrypt(response);

      const jsonArray = JSON.parse(decryptdata.replace(/\\"/g, '"'));

      if (jsonArray["Status count"] === "200") {
        toast.success("ip updated successfully");
        setTimeout(() => {
          window.location.reload();
        }, 1000); // optional delay for toast visibility
      } else {
        toast.error("Update failed");
      }
    } catch (error) {
      AxiosError(navigate, error);
      console.error("Error updating data:", error);
    }
  };

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const requestData = JSON.stringify({
          Dname: "flipopay_payouts",
          Tname: "ip_whitelist ",
          Cname: [
            "mid",
            "ip",
            "status"
          ],
          Where: [
            {
              column:"mid",
              operator:"=",
              value:id
            },
            {
              column:"status",
              operator:"=",
              value:"1"
            }
          ],
          Order: { "id": "desc" },
          Limit: "10",
          Offset: "0",
        });

        const encrypted = encrypt(requestData);
        const data = await makeAuthenticatedRequest(
          "POST",
          "/fetch",
          { encrypted },
          navigate
        );
        
        const decryptdata = decrypt(data);
        const fixedString = decryptdata.replace(/\\"/g, '"');
        const jsonArray = JSON.parse(fixedString);

        dispatch(Initiatepayoutmerchants_ip(jsonArray));

      } catch (err) {
        setError(err.message);
        AxiosError(navigate, err);
      }
    };

    fetchProfileData();
  }, [dispatch, id, navigate]);

  const ip = useSelector((state) => state.Initiatepayout.ip);
  const ip_details = ip && ip.length > 0 ? ip : [];

  return (
    <div className={`bg-[#F4F5FA] min-h-screen`}>
      {/* Header & Sidebar */}
      {/* <Header
        toggleSidebar={toggleSidebar}
        isSidebarCollapsed={isSidebarCollapsed}
      />
      <Sidebar
        isSidebarCollapsed={isSidebarCollapsed}
        toggleSidebar={toggleSidebar}
      /> */}

      <main className="main-content">
        <div
          className={`mx-auto p-4 md:p-4 transition-all duration-300 ${
            isSidebarCollapsed && !isMobile
              ? "lg:ml-20"
              : !isSidebarCollapsed && !isMobile
              ? "lg:ml-[270px]"
              : "ml-0"
          }`}
        >
          {/* Main Content */}
          <div className="mb-6 flex flex-wrap items-center justify-between ml-4">
            <div>
              <h2 className="text-xl font-semibold text-gray-800">IP Whitelist</h2>
              {/* <p className="text-sm text-gray-600 mt-1">Manage your account payouts and transactions</p> */}
            </div>
            <nav>
              <ol className="flex items-center space-x-2 text-sm">
                <li>
                  <Link
                    className="flex items-center text-gray-500 hover:text-[#299F1F] transition-colors"
                    to="/dashboard"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                      />
                    </svg>
                    Home
                  </Link>
                </li>
                <li className="text-gray-400">/</li>
                <li className="font-medium text-gray-800">IP Whitelist</li>
              </ol>
            </nav>
          </div>

          {/* Main content goes here */}
          <main className="main-content flex justify-center px-4 sm:px-6 lg:px-8">
            <div className="w-full max-w-3xl p-4">
              {/* Breadcrumb Start */}
              <div className="space-y-5 sm:space-y-6">
                <div className="rounded-2xl border border-gray-200 bg-white">
                  <div className="px-4 py-4 sm:px-6 sm:py-5">
                    <div className="flex justify-end">
                      <button
                        onClick={toggleModal}
                        className="bg-transparent border border-[#27ae60] text-[#27ae60] hover:bg-[#299F1F] hover:text-white font-semibold py-2 px-6 rounded-lg transition shadow-sm"
                      >
                        Add IP
                      </button>
                    </div>
                  </div>
                  {ip_details.slice(1).map((ip, index) => (
                    <div className="p-3 border-gray-100 flex items-center justify-center">
                    <div className="rounded-xl border border-gray-200 bg-[#F4F5FA] flex items-center justify-center w-full max-w-md h-12 text-lg">
                      {ip.ip}
                    </div>
                  </div>
                  ))}
                  {/* <div className="p-3 border-t border-gray-100 flex items-center justify-center">
                    <div className="rounded-xl border border-gray-200 bg-[#F4F5FA] flex items-center justify-center w-full max-w-md h-12 text-lg">
                      123.123.45.65
                    </div>
                  </div> */}
                </div>
              </div>
            </div>

            {/* ADD IP Modal */}
            {isModalVisible && (
              <div className="fixed inset-0 bg-gray-500 bg-opacity-80 flex justify-center items-center z-10 p-3">
                <div className="bg-white p-8 rounded-lg w-full max-w-xl h-[300px] mt-4 flex flex-col relative">
                  {/* Title and Close */}
                  <div className="flex justify-between items-center w-full">
                    <h3 className="text-xl font-medium text-gray-800 mb-1">
                      Add Payout IP
                    </h3>
                    
                    <button
                      onClick={toggleModal}
                      className="text-xl text-gray-800 hover:text-gray-600"
                    >
                      <span className="material-symbols-outlined">close</span>
                    </button>
                  </div>
                  <hr></hr>

                  <h3 className="text-lg text-gray-800 mt-5">
                    Enter version IV IP Address
                  </h3>

                  {/* Input Field */}
                  <div className="flex justify-center items-center mt-2">
                    <input
                      id="ipInput"
                      maxLength="15"
                      type="text"
                      value={ipAddress}
                      onChange={handleIpChange}
                      placeholder="Enter IP address"
                      className={`w-full px-3 py-2.5 rounded-md border ${
                        error ? "border-red-500" : "border-gray-300"
                      } focus:outline-none focus:ring-2 placeholder:text-sm text-sm ${
                        error ? "focus:ring-red-400" : "focus:ring-[#299F1F]"
                      }`}
                    />
                  </div>

                  {error && (
                    <p className="text-red-500 text-sm mt-2">
                      {error}
                    </p>
                  )}

                  {/* Submit Button */}
                  <div className="mt-auto flex w-full">
                    <button
                      onClick={handleSubmit}
                      className="bg-transparent w-full border border-[#27ae60] text-[#27ae60] hover:bg-[#299F1F] hover:text-white font-semibold py-2 px-6 rounded-lg transition shadow-sm"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </main>
        </div>
      </main>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default UpdateIP;
